const researches = [
    {
        title: "A machine learning framework for promoter identification: integrating explainable AI for genomic insights\n",
        site: "Journal of Electrical Systems and Information Technology (JESIT)",
        link: "https://link.springer.com/article/10.1186/s43067-026-00339-9",
        location: "Springer Nature"
    },

    {
        title: "Unraveling Urban Traffic Congestion Patterns in Bangladesh\n",
        site: "11th International Conference on Vehicle Technology and Intelligent Transport Systems - VEHITS 2025",
        link: "https://www.scitepress.org/PublicationsDetail.aspx?ID=C6x1Jje/Ncw=&t=1",
        location: "Porto, Portugal"
    },

    {
        title: "IoT-Enabled Real-Time Health Analytics Using Integrated Multi-Modal Biomedical Sensors\n",
        site: "Journal of the Patuakhali Science and Technology University",
        link: "https://journal.pstu.ac.bd/",
        location: "Dumki, Patuakhali"
    },

];

export default researches;
